import { Pipe, PipeTransform } from '@angular/core';
import { CancellationReason } from '@sgm-frontend/core';

@Pipe({
  name: 'cancellationReason'
})
export class CancellationReasonPipe implements PipeTransform {

 transform(value: CancellationReason | string): string {
    if (!value) {
      return '';
    }

    // You can use a switch statement or an object lookup for more complex mappings
    switch (value) {
      case CancellationReason.change_of_mind:
        return 'Change of mind';
      case CancellationReason.found_better_price:
        return 'Found better price';
      case CancellationReason.delivery_delay:
        return 'Delivery delay';
      case CancellationReason.purchased_from_branch:
        return 'Purchased from branch';
      case CancellationReason.financial_conditions:
        return 'Financial conditions';
      case CancellationReason.incorrect_shipping_address:
        return 'Incorrect shipping address';
      case CancellationReason.incorrect_shipping_method:
        return 'Incorrect shipping method';
      case CancellationReason.incorrect_payment_information:
        return 'Incorrect payment information';
      default:
        // Fallback for any unknown reasons or if value is already user-friendly
        // You might want to format it, e.g., "unknown_reason" -> "Unknown Reason"
        return null;
    }
  }

}
